module.exports = __webpack_public_path__ + "img/scan (15).d5148ec1.jpg";